import { Component, Input } from '@angular/core';

interface Price {
  value: number,
  currency: string
}

@Component({
  selector: 'app-price',
  template: `{{ price.value | currency: price.currency}}`
})
export class PriceComponent {
  public _price: Price;

  @Input() set price(price: Price) {
    this._price = { value: price.value / 100 , currency: price.currency };
  }

  get price() {
    return this._price
  }
}
